export default __webpack_public_path__ + "static/media/think-about-it.ce4404ce.gif";